export var ViewMarkup;
(function (ViewMarkup) {
    ViewMarkup["BUTTON"] = "button";
    ViewMarkup["INPUT"] = "input";
    ViewMarkup["A"] = "a";
    ViewMarkup["SPAN"] = "span";
    ViewMarkup["DIV"] = "div";
    ViewMarkup["P"] = "p";
    ViewMarkup["UL"] = "ul";
    ViewMarkup["LI"] = "li";
    ViewMarkup["LABEL"] = "label";
    ViewMarkup["DETAILS"] = "details";
    ViewMarkup["SUMMARY"] = "summary";
})(ViewMarkup || (ViewMarkup = {}));
//# sourceMappingURL=ViewProps.js.map